var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowsAltH = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.4596 17.4697C18.1667 17.1768 18.1667 16.7019 18.4596 16.409L21.3687 13.5L14.25 13.5C13.8358 13.5 13.5 13.1642 13.5 12.75C13.5 12.3358 13.8358 12 14.25 12L21.4752 12L18.4596 8.98441C18.1667 8.69152 18.1667 8.21665 18.4596 7.92375C18.7525 7.63086 19.2274 7.63086 19.5203 7.92375L23.7629 12.1664C24.0558 12.4593 24.0558 12.9342 23.7629 13.2271L19.5203 17.4697C19.2274 17.7626 18.7525 17.7626 18.4596 17.4697ZM5.54037 8.03031C5.83326 8.3232 5.83326 8.79808 5.54037 9.09097L2.63133 12L9.75 12C10.1642 12 10.5 12.3358 10.5 12.75C10.5 13.1642 10.1642 13.5 9.75 13.5H2.52478L5.54037 16.5156C5.83326 16.8085 5.83326 17.2834 5.54037 17.5763C5.24747 17.8691 4.7726 17.8691 4.47971 17.5763L0.237065 13.3336C-0.0558282 13.0407 -0.0558284 12.5658 0.237065 12.273L4.47971 8.03031C4.7726 7.73742 5.24747 7.73742 5.54037 8.03031Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowsAltH);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrows-alt-h.9da445ddb0199259f74f97e651fb0e99.svg";